/**
 * fv-product-landingpage-1 — scoped interactions
 * Direct checkout, sticky CTA, legal modals, FAQ, delivery line
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-fv-plp1-root]');
  if (!root) return;

  var config = {
    variantId: root.getAttribute('data-variant-id'),
    productHandle: root.getAttribute('data-product-handle') || '',
    available: root.getAttribute('data-available') === 'true',
    soldOutText: root.getAttribute('data-sold-out-text') || 'Uitverkocht',
    loadingText: root.getAttribute('data-loading-text') || 'Even geduld…',
    ctaShort: root.getAttribute('data-cta-short') || 'Toevoegen',
    ctaFull: root.getAttribute('data-cta-full') || 'Toevoegen aan winkelwagen',
    landingPage: 'product-landingpage-1',
    source: 'freevolt-social-test',
    timezone: 'Europe/Amsterdam',
    cutoffHour: 17
  };

  var ctas = root.querySelectorAll('[data-fv-checkout]');
  var stickyBar = root.querySelector('[data-fv-sticky]');
  var deliveryEls = root.querySelectorAll('[data-fv-delivery-date]');
  var modal = root.querySelector('[data-fv-legal-modal]');
  var modalTitle = modal ? modal.querySelector('[data-fv-modal-title]') : null;
  var modalBody = modal ? modal.querySelector('[data-fv-modal-body]') : null;
  var legalData = {};

  try {
    var legalScript = root.querySelector('script[data-fv-legal-json]');
    if (legalScript) {
      legalData = JSON.parse(legalScript.textContent);
    } else {
      legalData = JSON.parse(root.getAttribute('data-legal-json') || '{}');
    }
  } catch (e) {
    legalData = {};
  }

  function shopifyRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function fetchJson(url, options) {
    return fetch(url, options).then(function (res) {
      if (!res.ok) throw new Error('Request failed: ' + res.status);
      return res.json();
    });
  }

  function setCtaLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.dataset.loading = 'true';
      btn.disabled = true;
      btn.classList.add('fv-plp1__cta--loading');
      if (!btn.dataset.originalLabel) {
        btn.dataset.originalLabel = btn.innerHTML;
      }
      btn.textContent = config.loadingText;
    } else {
      btn.dataset.loading = 'false';
      btn.classList.remove('fv-plp1__cta--loading');
      if (btn.dataset.originalLabel) {
        btn.innerHTML = btn.dataset.originalLabel;
      }
      if (config.available) {
        btn.disabled = false;
      }
    }
  }

  function setAllCtasLoading(loading) {
    ctas.forEach(function (btn) {
      setCtaLoading(btn, loading);
    });
  }

  function getCtaSource(btn) {
    if (!btn) return 'landingpage_cta';
    var src = (btn.getAttribute('data-fv-cta-source') || '').trim();
    return src || 'landingpage_cta';
  }

  function buildAttribution(ctaSource) {
    var path = '';
    try {
      path = window.location.pathname + window.location.search;
    } catch (e) {
      path = '';
    }
    return {
      pageLabel: 'Product landingpage 1',
      sourceLabel: config.source,
      templateLabel: 'page.product-landingpage-1',
      productHandle: config.productHandle || '',
      landingUrl: path,
      referrer: document.referrer || '',
      ctaSource: ctaSource || 'landingpage_cta'
    };
  }

  var LANDING_CART_PATH = '/cart';
  var UNIT_CENTS = 22900;
  var cartAwareActive = false;
  var stickyAdd = stickyBar ? stickyBar.querySelector('[data-fv-sticky-add]') : null;
  var stickyCart = stickyBar ? stickyBar.querySelector('[data-fv-sticky-cart]') : null;
  var stickyCartQty = stickyBar ? stickyBar.querySelector('[data-fv-sticky-cart-qty]') : null;
  var stickyCartTotal = stickyBar ? stickyBar.querySelector('[data-fv-sticky-cart-total]') : null;

  function setFunnelFlag() {
    try {
      if (window.FVLandingFunnel && typeof window.FVLandingFunnel.set === 'function') {
        window.FVLandingFunnel.set();
        return;
      }
      sessionStorage.setItem('fv_landing_funnel', '1');
    } catch (e) {}
  }

  function moneyValue(cents) {
    return Math.round(cents) / 100;
  }

  function formatMoney(cents) {
    var value = (Math.round(cents) / 100).toFixed(2).replace('.', ',');
    return '€' + value;
  }

  function pushFvEvent(eventName, payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      var data = { event: eventName };
      if (payload) {
        for (var key in payload) {
          if (Object.prototype.hasOwnProperty.call(payload, key)) {
            data[key] = payload[key];
          }
        }
      }
      window.dataLayer.push(data);
    } catch (e) {
      /* tracking must never block */
    }
  }

  function trackAddToCart(attrib, quantity) {
    var qty = quantity || 1;
    pushFvEvent('fv_lp_add_to_cart', {
      variant_id: config.variantId,
      quantity: qty,
      cta_source: attrib.ctaSource,
      product_handle: attrib.productHandle,
      landing_page: attrib.pageLabel,
      value: moneyValue(UNIT_CENTS * qty),
      currency: 'EUR'
    });
  }

  function getLandingItem(cart) {
    if (!cart || !cart.items || !cart.items.length || !config.variantId) return null;
    var targetVariant = String(config.variantId);
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var props = item.properties || {};
      if (String(item.variant_id) !== targetVariant) continue;
      if (props._landing_page === 'Product landingpage 1') return item;
    }
    return null;
  }

  function cartHasOnlyLandingItem(cart, landingItem) {
    if (!cart || !landingItem || !cart.items || cart.items.length !== 1) return false;
    return cart.items[0].key === landingItem.key;
  }

  function cartHasDirtySameVariant(cart) {
    if (!cart || !cart.items || !config.variantId) return false;
    var targetVariant = String(config.variantId);
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (String(item.variant_id) !== targetVariant) continue;
      var props = item.properties || {};
      if (props._landing_page !== 'Product landingpage 1') return true;
    }
    return false;
  }

  function updateCartAttributes(attrib) {
    return fetchJson(shopifyRoot() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          __landing_page: attrib.pageLabel,
          __landing_source: attrib.sourceLabel,
          __landing_template: attrib.templateLabel,
          __product_handle: attrib.productHandle,
          __landing_url: attrib.landingUrl,
          __referrer: attrib.referrer,
          __cta_source: attrib.ctaSource
        }
      })
    });
  }

  function addLandingItem(attrib) {
    return fetchJson(shopifyRoot() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: config.variantId,
        quantity: 1,
        properties: {
          _landing_page: attrib.pageLabel,
          _landing_source: attrib.sourceLabel,
          _landing_template: attrib.templateLabel,
          _product_handle: attrib.productHandle,
          _cta_source: attrib.ctaSource
        }
      })
    });
  }

  function clearCart() {
    return fetchJson(shopifyRoot() + 'cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
  }

  function goToLandingCart() {
    setFunnelFlag();
    window.location.href = shopifyRoot().replace(/\/?$/, '/') + LANDING_CART_PATH.replace(/^\//, '');
  }

  function showCtaError(btn, message) {
    setAllCtasLoading(false);
    if (!btn) return;
    if (!btn.dataset.originalLabel) {
      btn.dataset.originalLabel = btn.innerHTML;
    }
    btn.textContent = message || 'Probeer opnieuw';
    btn.disabled = false;
    window.setTimeout(function () {
      if (btn.dataset.originalLabel) {
        btn.innerHTML = btn.dataset.originalLabel;
      }
    }, 2200);
  }

  function updateHeaderCartCount(cart) {
    var countEl = document.querySelector('[data-fv-header-cart-count]');
    var badgeEl = document.querySelector('[data-fv-header-cart-badge]');
    var count = cart && cart.item_count ? cart.item_count : 0;
    var link = (countEl && countEl.closest('a')) || (badgeEl && badgeEl.closest('a'));

    if (countEl) {
      if (count > 0) {
        countEl.textContent = ' (' + count + ')';
        countEl.hidden = false;
      } else {
        countEl.textContent = '';
        countEl.hidden = true;
      }
    }

    if (badgeEl) {
      if (count > 0) {
        badgeEl.textContent = String(count);
        badgeEl.hidden = false;
      } else {
        badgeEl.textContent = '';
        badgeEl.hidden = true;
      }
    }

    if (link) {
      link.setAttribute('aria-label', count > 0 ? 'Winkelwagen (' + count + ')' : 'Winkelwagen');
    }
  }

  function setCartAwareFooter(active, qty, lineCents) {
    cartAwareActive = !!active;
    root.classList.toggle('fv-plp1--cart-active', cartAwareActive);

    if (!stickyBar) return;

    stickyBar.classList.toggle('fv-plp1__sticky--cart', cartAwareActive);
    stickyBar.classList.toggle('fv-plp1__sticky--add', !cartAwareActive);

    if (stickyAdd) stickyAdd.hidden = cartAwareActive;
    if (stickyCart) stickyCart.hidden = !cartAwareActive;

    if (cartAwareActive) {
      stickyBar.classList.add('is-visible');
      var count = qty || 1;
      var cartTotal = lineCents != null ? lineCents : UNIT_CENTS * count;
      if (stickyCartQty) stickyCartQty.textContent = count === 1 ? '1 item' : count + ' items';
      if (stickyCartTotal) stickyCartTotal.textContent = formatMoney(cartTotal);
    }
  }

  function syncCartAwareFromCart(cart) {
    updateHeaderCartCount(cart);
    var landingItem = getLandingItem(cart);
    if (landingItem) {
      setCartAwareFooter(true, landingItem.quantity || 1, landingItem.final_line_price);
    } else {
      setCartAwareFooter(false);
    }
  }

  function directCheckout(clickedBtn) {
    if (!config.available || !config.variantId) return;
    if (clickedBtn && clickedBtn.dataset.loading === 'true') return;

    setFunnelFlag();
    var rootPath = shopifyRoot();
    var ctaSource = getCtaSource(clickedBtn);
    var attrib = buildAttribution(ctaSource);
    setAllCtasLoading(true);

    fetchJson(rootPath + 'cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (cart) {
        var landingItem = getLandingItem(cart);
        var itemCount = cart && cart.item_count ? cart.item_count : 0;

        // C: only correct landing-set already in cart → keep qty, update attrs, redirect
        if (landingItem && cartHasOnlyLandingItem(cart, landingItem)) {
          return updateCartAttributes(attrib).then(function () {
            syncCartAwareFromCart({
              item_count: landingItem.quantity,
              items: [landingItem]
            });
            trackAddToCart(attrib, landingItem.quantity || 1);
            goToLandingCart();
          });
        }

        // D: empty cart → add
        if (!itemCount) {
          return addLandingItem(attrib)
            .then(function () {
              return updateCartAttributes(attrib);
            })
            .then(function () {
              setCartAwareFooter(true, 1);
              trackAddToCart(attrib, 1);
              goToLandingCart();
            });
        }

        // E/F: mixed cart OR dirty same-variant without landing properties → clear + add
        if (
          (landingItem && !cartHasOnlyLandingItem(cart, landingItem)) ||
          cartHasDirtySameVariant(cart) ||
          !landingItem
        ) {
          return clearCart()
            .then(function () {
              return addLandingItem(attrib);
            })
            .then(function () {
              return updateCartAttributes(attrib);
            })
            .then(function () {
              setCartAwareFooter(true, 1);
              trackAddToCart(attrib, 1);
              goToLandingCart();
            });
        }

        return updateCartAttributes(attrib).then(function () {
          trackAddToCart(attrib, landingItem ? landingItem.quantity || 1 : 1);
          goToLandingCart();
        });
      })
      .catch(function () {
        showCtaError(clickedBtn, 'Probeer opnieuw');
      });
  }

  function bindCheckout() {
    if (!config.available || !config.variantId) {
      ctas.forEach(function (btn) {
        btn.disabled = true;
      });
      return;
    }

    ctas.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        directCheckout(btn);
      });
    });
  }

  /* ── Delivery line (Europe/Amsterdam) ── */
  var DAYS = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  var MONTHS = [
    'januari', 'februari', 'maart', 'april', 'mei', 'juni',
    'juli', 'augustus', 'september', 'oktober', 'november', 'december'
  ];

  function getAmsterdamParts() {
    var formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: config.timezone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      hour12: false,
      weekday: 'short'
    });
    var parts = formatter.formatToParts(new Date());
    var map = {};
    parts.forEach(function (p) {
      map[p.type] = p.value;
    });
    var weekdayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    return {
      year: parseInt(map.year, 10),
      month: parseInt(map.month, 10) - 1,
      day: parseInt(map.day, 10),
      hour: parseInt(map.hour, 10),
      weekday: weekdayMap[map.weekday] != null ? weekdayMap[map.weekday] : 0
    };
  }

  function makeDate(y, m, d) {
    return new Date(Date.UTC(y, m, d, 12, 0, 0));
  }

  function nextWorkingDayFrom(parts) {
    var d = makeDate(parts.year, parts.month, parts.day);
    d.setUTCDate(d.getUTCDate() + 1);
    while (d.getUTCDay() === 0 || d.getUTCDay() === 6) {
      d.setUTCDate(d.getUTCDate() + 1);
    }
    return d;
  }

  function formatDeliveryLabel() {
    try {
      var now = getAmsterdamParts();
      var base = { year: now.year, month: now.month, day: now.day };
      if (now.hour >= config.cutoffHour) {
        var bumped = makeDate(base.year, base.month, base.day);
        bumped.setUTCDate(bumped.getUTCDate() + 1);
        base = {
          year: bumped.getUTCFullYear(),
          month: bumped.getUTCMonth(),
          day: bumped.getUTCDate()
        };
      }
      var delivery = nextWorkingDayFrom(base);
      return (
        DAYS[delivery.getUTCDay()] +
        ' ' +
        delivery.getUTCDate() +
        ' ' +
        MONTHS[delivery.getUTCMonth()]
      );
    } catch (e) {
      return null;
    }
  }

  function initDelivery() {
    var label = formatDeliveryLabel();
    deliveryEls.forEach(function (el) {
      if (label) {
        el.textContent = 'Geleverd op ' + label + ' in NL/BE';
      } else {
        el.textContent = 'morgen in huis in NL/BE';
      }
    });
  }

  /* ── Sticky CTA ── */
  function initSticky() {
    if (!stickyBar) return;

    var startEl = document.getElementById('wat-je-krijgt') || document.getElementById('fv-plp1-included');
    var finalEl = root.querySelector('.fv-plp1__final') || document.getElementById('fv-plp1-final');
    if (!startEl) return;

    function update() {
      if (cartAwareActive) {
        stickyBar.classList.add('is-visible');
        return;
      }
      var startTop = startEl.getBoundingClientRect().top;
      var finalTop = finalEl
        ? finalEl.getBoundingClientRect().top
        : Number.POSITIVE_INFINITY;
      var show = startTop <= 96 && finalTop > window.innerHeight * 0.92;
      stickyBar.classList.toggle('is-visible', show);
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function initCartAwareFooter() {
    if (!config.variantId) return;

    if (stickyCart) {
      stickyCart.addEventListener('click', function (e) {
        var link = e.target && e.target.closest ? e.target.closest('a[href*="/cart"], a[href*="complete-set-winkelwagen"]') : null;
        if (!link) return;
        setFunnelFlag();
      });
    }

    root.querySelectorAll('a[href*="/cart"], a[href*="complete-set-winkelwagen"]').forEach(function (link) {
      link.addEventListener('click', function () {
        setFunnelFlag();
      });
    });

    fetchJson(shopifyRoot() + 'cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (cart) {
        syncCartAwareFromCart(cart);
      })
      .catch(function () {
        setCartAwareFooter(false);
      });
  }

  /* ── FAQ ── */
  function initFaq() {
    var items = root.querySelectorAll('[data-fv-faq-item]');
    items.forEach(function (item, index) {
      var btn = item.querySelector('[data-fv-faq-toggle]');
      if (!btn) return;
      if (index === 0) item.classList.add('is-open');
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (other) {
          other.classList.remove('is-open');
          var otherBtn = other.querySelector('[data-fv-faq-toggle]');
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ── Legal modals ── */
  function openModal(key) {
    if (!modal || !legalData[key]) return;
    var entry = legalData[key];
    if (modalTitle) modalTitle.textContent = entry.title;
    if (modalBody) {
      if (entry.html) {
        modalBody.innerHTML = entry.html;
      } else if (entry.body && Array.isArray(entry.body)) {
        modalBody.innerHTML = entry.body
          .map(function (p) {
            return '<p>' + escapeHtml(p) + '</p>';
          })
          .join('');
      } else {
        modalBody.innerHTML = '<p>Deze tekst wordt binnenkort toegevoegd.</p>';
      }
    }
    modal.hidden = false;
    document.body.classList.add('fv-plp1-modal-open');
    var closeBtn = modal.querySelector('[data-fv-modal-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('fv-plp1-modal-open');
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function initModals() {
    root.querySelectorAll('[data-fv-legal]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal(btn.getAttribute('data-fv-legal'));
      });
    });

    if (!modal) return;

    modal.querySelectorAll('[data-fv-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      var galleryModal = root.querySelector('[data-fv-gallery-modal]');
      if (galleryModal && !galleryModal.hidden) return;
      var videoModal = root.querySelector('[data-fv-video-modal]');
      if (videoModal && !videoModal.hidden) return;
      var specsModal = root.querySelector('[data-fv-specs-modal]');
      if (specsModal && !specsModal.hidden) return;
      var contactModal = document.querySelector('[data-fv-contact-modal]');
      if (contactModal && !contactModal.hidden) return;
      if (e.key === 'Escape' && modal && !modal.hidden) {
        closeModal();
      }
    });
  }

  /* ── Product image gallery lightbox ── */
  function initGallery() {
    var galleryModal = root.querySelector('[data-fv-gallery-modal]');
    if (!galleryModal) return;

    var imageEl = galleryModal.querySelector('[data-fv-gallery-image]');
    var counterEl = galleryModal.querySelector('[data-fv-gallery-counter]');
    var prevBtn = galleryModal.querySelector('[data-fv-gallery-prev]');
    var nextBtn = galleryModal.querySelector('[data-fv-gallery-next]');
    var items = [];
    var activeIndex = 0;
    var touchStartX = null;

    function normalizeSrc(src) {
      if (!src) return '';
      try {
        var url = new URL(src, window.location.origin);
        var path = url.pathname.replace(/_(?:\d+x(?:\d+)?)(\.[a-z0-9]+)$/i, '$1');
        return path + (url.search || '');
      } catch (e) {
        return String(src).split('?')[0];
      }
    }

    function collectItems() {
      var unique = [];
      var seen = {};
      root.querySelectorAll('[data-fv-gallery-item]').forEach(function (el) {
        var src = el.getAttribute('data-fv-gallery-src') || '';
        if (!src) return;
        var key = normalizeSrc(src);
        if (!key || seen[key]) return;
        seen[key] = true;
        unique.push({
          src: src,
          alt: el.getAttribute('data-fv-gallery-alt') || '',
          key: key
        });
      });
      items = unique;
      galleryModal.setAttribute('data-count', String(items.length));
      if (prevBtn) prevBtn.hidden = items.length < 2;
      if (nextBtn) nextBtn.hidden = items.length < 2;
    }

    function render() {
      if (!items.length || !imageEl) return;
      var item = items[activeIndex];
      if (!item) return;
      imageEl.src = item.src;
      imageEl.alt = item.alt || '';
      if (counterEl) {
        counterEl.textContent = items.length > 1 ? activeIndex + 1 + ' / ' + items.length : '';
      }
    }

    function openAt(index) {
      if (!items.length) collectItems();
      if (!items.length) return;
      activeIndex = ((index % items.length) + items.length) % items.length;
      galleryModal.hidden = false;
      document.documentElement.classList.add('fv-plp1-gallery-open');
      document.body.classList.add('fv-plp1-gallery-open');
      render();
      if (galleryModal.querySelector('[data-fv-gallery-close]')) {
        galleryModal.querySelector('[data-fv-gallery-close]').focus();
      }
    }

    function closeGallery() {
      galleryModal.hidden = true;
      document.documentElement.classList.remove('fv-plp1-gallery-open');
      document.body.classList.remove('fv-plp1-gallery-open');
      if (imageEl) {
        imageEl.removeAttribute('src');
        imageEl.alt = '';
      }
    }

    function step(delta) {
      if (items.length < 2) return;
      activeIndex = (activeIndex + delta + items.length) % items.length;
      render();
    }

    function indexForTrigger(trigger) {
      var src = trigger.getAttribute('data-fv-gallery-src') || '';
      var key = normalizeSrc(src);
      for (var i = 0; i < items.length; i++) {
        if (items[i].key === key) return i;
      }
      return 0;
    }

    collectItems();

    root.addEventListener('click', function (e) {
      var trigger = e.target && e.target.closest ? e.target.closest('[data-fv-gallery-item]') : null;
      if (!trigger || !root.contains(trigger)) return;
      e.preventDefault();
      collectItems();
      openAt(indexForTrigger(trigger));
    });

    galleryModal.querySelectorAll('[data-fv-gallery-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closeGallery();
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        step(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        step(1);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (galleryModal.hidden) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closeGallery();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        step(-1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        step(1);
      }
    });

    galleryModal.addEventListener(
      'touchstart',
      function (e) {
        if (!e.changedTouches || !e.changedTouches.length) return;
        touchStartX = e.changedTouches[0].clientX;
      },
      { passive: true }
    );

    galleryModal.addEventListener(
      'touchend',
      function (e) {
        if (touchStartX == null || !e.changedTouches || !e.changedTouches.length) return;
        var delta = e.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(delta) < 48) return;
        step(delta > 0 ? -1 : 1);
      },
      { passive: true }
    );

    if (imageEl) {
      imageEl.addEventListener('error', function () {
        var item = items[activeIndex];
        if (!item || !item.src) return;
        var fallback = item.src.replace(/width=\d+/i, 'width=900');
        if (fallback !== imageEl.src) imageEl.src = fallback;
      });
    }
  }

  /* ── Creator video modal ── */
  function initCreatorVideo() {
    var videoModal = root.querySelector('[data-fv-video-modal]');
    if (!videoModal) return;

    var player = videoModal.querySelector('[data-fv-video-player]');
    var titleEl = videoModal.querySelector('[data-fv-video-title]');
    var linkEl = videoModal.querySelector('[data-fv-video-link]');
    if (!player) return;

    var lastTrigger = null;

    function openVideo(trigger) {
      var src = trigger.getAttribute('data-fv-video-src');
      if (!src) return;

      lastTrigger = trigger;
      var poster = trigger.getAttribute('data-fv-video-poster') || '';
      var title = trigger.getAttribute('data-fv-video-title') || '';
      var link = trigger.getAttribute('data-fv-video-link') || '';

      if (titleEl) titleEl.textContent = title;
      if (linkEl) {
        if (link) {
          linkEl.href = link;
          linkEl.hidden = false;
        } else {
          linkEl.removeAttribute('href');
          linkEl.hidden = true;
        }
      }

      if (poster) {
        player.setAttribute('poster', poster);
      } else {
        player.removeAttribute('poster');
      }
      player.setAttribute('preload', 'auto');
      player.src = src;

      videoModal.hidden = false;
      document.documentElement.classList.add('fv-plp1-gallery-open');
      document.body.classList.add('fv-plp1-gallery-open');

      var closeBtn = videoModal.querySelector('[data-fv-video-close]');
      if (closeBtn) closeBtn.focus();

      var playAttempt = player.play();
      if (playAttempt && typeof playAttempt.catch === 'function') {
        // Autoplay with sound can be blocked; the controls stay available.
        playAttempt.catch(function () {});
      }
    }

    function closeVideo() {
      if (videoModal.hidden) return;
      videoModal.hidden = true;
      document.documentElement.classList.remove('fv-plp1-gallery-open');
      document.body.classList.remove('fv-plp1-gallery-open');

      player.pause();
      player.removeAttribute('src');
      player.removeAttribute('poster');
      player.setAttribute('preload', 'none');
      player.load();

      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
      lastTrigger = null;
    }

    root.addEventListener('click', function (e) {
      var trigger = e.target && e.target.closest ? e.target.closest('[data-fv-video-open]') : null;
      if (!trigger || !root.contains(trigger)) return;
      e.preventDefault();
      openVideo(trigger);
    });

    videoModal.querySelectorAll('[data-fv-video-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closeVideo();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (videoModal.hidden) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closeVideo();
      }
    });
  }

  /* ── Technical specs modal ── */
  function initSpecsModal() {
    var specsModal = root.querySelector('[data-fv-specs-modal]');
    if (!specsModal) return;

    var lastTrigger = null;

    function openSpecs(trigger) {
      lastTrigger = trigger;
      specsModal.hidden = false;
      document.documentElement.classList.add('fv-plp1-gallery-open');
      document.body.classList.add('fv-plp1-gallery-open');

      var titleEl = specsModal.querySelector('.fv-plp1__specs-modal-title');
      if (titleEl) titleEl.focus();
    }

    function closeSpecs() {
      if (specsModal.hidden) return;
      specsModal.hidden = true;
      document.documentElement.classList.remove('fv-plp1-gallery-open');
      document.body.classList.remove('fv-plp1-gallery-open');

      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
      lastTrigger = null;
    }

    root.addEventListener('click', function (e) {
      var trigger = e.target && e.target.closest ? e.target.closest('[data-fv-specs-open]') : null;
      if (!trigger || !root.contains(trigger)) return;
      e.preventDefault();
      openSpecs(trigger);
    });

    specsModal.querySelectorAll('[data-fv-specs-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closeSpecs();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (specsModal.hidden) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closeSpecs();
      }
    });
  }

  /* ── Smooth anchor scroll (native fallback) ── */
  function initAnchors() {
    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href').slice(1);
        if (!id) return;
        var target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ── Contact success: land slightly above the form after native redirect ── */
  function initContactSuccessScroll() {
    var note = root.querySelector('[data-fv-contact-success]');
    if (!note) return;

    var section = document.getElementById('fv-plp1-contact') || note;
    var offset = 88;

    function scrollToContact() {
      var top = section.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
      try {
        note.focus({ preventScroll: true });
      } catch (err) {
        /* older browsers */
      }
    }

    /* Override the browser hash jump to #fv-plp1-contact-form */
    window.setTimeout(scrollToContact, 0);
    window.setTimeout(scrollToContact, 50);
  }

  function init() {
    bindCheckout();
    initDelivery();
    initSticky();
    initCartAwareFooter();
    initFaq();
    initModals();
    initGallery();
    initCreatorVideo();
    initSpecsModal();
    initAnchors();
    initContactSuccessScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
